if (document.querySelector('#product')) {
  document.querySelectorAll('#tab-menu .menu-link').forEach(link => {
    link.addEventListener('click', function () {
      changeActiveTab(this.getAttribute('data-id'));
    });
  });

  document.querySelectorAll('.doublebox .btn').forEach(button => {
    button.addEventListener('click', function () {
      changeActiveTab(this.getAttribute('data-id'));
      document.querySelector('#tab-menu').scrollIntoView();
    });
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.sub-tab-menu input[type="radio"]')) {
      const menuId = event.target.closest('.sub-tab-menu').id;
      const tabId = event.target.value;
      changeActiveSubTab(menuId, tabId);
    }
  });
}

if (
  document.querySelector('.product-id-14') ||
  document.querySelector('.product-id-13') ||
  document.querySelector('.product-id-30')
) {
  const hash = window.location.hash.substr(1);
  if (hash.includes('product-') && document.getElementById(hash)) {
    window.addEventListener('load', function () {
      changeActiveTab(hash);
      document.querySelector('#tab-menu').scrollIntoView();
    });
  }
  document.addEventListener('DOMContentLoaded', toggleSpecialOfferTab);
}

function changeActiveTab(tabId) {
  document.querySelectorAll('#tab-menu .menu-link').forEach(link => {
    link.classList.remove('current');
  });

  const activeLink = document.querySelector('#tab-menu .menu-link[data-id="' + tabId + '"]');
  if (activeLink) activeLink.classList.add('current');

  document.querySelectorAll('#tab-content .tab').forEach(tab => {
    tab.style.display = 'none';
  });

  const activeTab = document.querySelector('#tab-content .tab#' + tabId);
  if (activeTab) activeTab.style.display = 'block';
}

function changeActiveSubTab(menuId, tabId) {
  const subTabs = document.querySelectorAll('#' + menuId.replace('menu', 'content') + ' .sub-tab');
  subTabs.forEach(subTab => (subTab.style.display = 'none'));

  const activeSubTab = document.querySelector('#' + menuId.replace('menu', 'content') + ' .sub-tab#' + tabId);
  if (activeSubTab) activeSubTab.style.display = 'block';
}

function toggleSpecialOfferTab() {
  const specialOfferTab = document.querySelector('.menu-link[data-id="product-special-offer"]');
  const specialOfferContent = document.querySelector('#product-special-offer');

  if (specialOfferTab && specialOfferContent) {
    const hasContent = specialOfferContent.children.length > 0;
    specialOfferTab.style.display = hasContent ? 'block' : 'none';
  }
}
